import React from 'react';
import { Route, Routes } from 'react-router-dom';
import PrivateRoute from './services/Permission/PrivateRoute'
import AcessoNegado from './views/Pages/AcessoNegado';
import NotFound from './views/Pages/NotFound';
import Login from './views/Pages/Login';
import BrowserInvalido from './views/Pages/BrowserInvalido';
import { Loading } from './components';
import './scss/style.scss';
import Formulario from './views/Formulario';
import Finish from './views/Formulario/Finish';
import AuthCallback from './views/Pages/Mfa/AuthCallback';

const Default = React.lazy(() => import('./containers/Default'));

const App = () => {
  return (
    <React.Suspense fallback={Loading}>
      <Routes>
        <Route path="/formulario" name="Formulário" element={<Formulario />} />
        <Route path="/finish" name="Empresa Convênio - Cadastrado com Sucesso" element={<Finish />} />
        <Route path="/login" name="Login Page" element={<Login />} />
        <Route path="/404" name="Page 404" element={<NotFound />} />
        <Route path="/500" name="Page 500" element={<AcessoNegado />} />
        <Route path="/browserInvalido" name="Browser Inválido" element={<BrowserInvalido />} />
        <Route path="/auth-callback" element={<AuthCallback />} />
        <Route path="*" name="Home"
          element={
            <PrivateRoute>
              <Default />
            </PrivateRoute>
          }
        />
      </Routes>
    </React.Suspense>
  );
}

export default App;